import { BookOpen, Image as ImageIcon } from "@phosphor-icons/react";

// Live, on-screen preview only. Photos shown here are local data URLs.
export function EbookPreview({ title, author, dedication, contents, photos, sectionText }) {
  const cover = photos.find((p) => p.target === "cover");
  return (
    <div>
      <div className="flex items-center gap-2 text-sm font-semibold text-[#A84A32]">
        <BookOpen size={18} weight="fill" /> Ebook preview
      </div>
      <div data-testid="ebook-preview" className="ph-no-capture mt-3 overflow-hidden rounded-2xl border border-[#4A4540]/15 bg-white shadow-sm">
        <div className="bg-[#2E3B31] px-6 py-10 text-center text-[#FBF4E8]">
          {cover ? (
            <img data-testid="preview-cover-photo" src={cover.dataUrl} alt="cover" className="mx-auto max-h-40 rounded-lg object-contain ring-2 ring-[#FBF4E8]/40" />
          ) : (
            <div className="mx-auto flex h-28 w-28 items-center justify-center rounded-lg bg-[#FBF4E8]/10 text-[#FBF4E8]/50"><ImageIcon size={30} /></div>
          )}
          <h4 data-testid="preview-title" className="mt-4 font-serif text-2xl">{title || "My Life Story"}</h4>
          {author && <p className="mt-1 text-sm italic text-[#FBF4E8]/80">{author}</p>}
        </div>
        <div className="max-h-[420px] space-y-4 overflow-y-auto p-6 text-sm">
          {dedication && (
            <div>
              <p className="text-[11px] font-semibold uppercase tracking-wide text-[#8A7F76]">Dedication</p>
              <p className="mt-1 whitespace-pre-line italic text-[#4A4540]">“{dedication}”</p>
            </div>
          )}
          <div className="border-t border-[#4A4540]/10 pt-3">
            <p className="text-[11px] font-semibold uppercase tracking-wide text-[#8A7F76]">Contents</p>
            <ol data-testid="preview-contents" className="mt-1 list-inside list-decimal text-[#4A4540]">
              {contents.map((c) => <li key={c.key}>{c.label}</li>)}
            </ol>
          </div>
          {contents.map((c) => {
            const pics = photos.filter((p) => c.photoTargets?.includes(p.target));
            if (!pics.length && !sectionText?.[c.key]) return null;
            return (
              <div key={c.key} className="border-t border-[#4A4540]/10 pt-3">
                <p className="text-[11px] font-semibold uppercase tracking-wide text-[#8A7F76]">{c.label}</p>
                {sectionText?.[c.key] && <p className="mt-1 line-clamp-3 text-[#4A4540]">{sectionText[c.key]}</p>}
                {pics.map((p, i) => <img key={i} src={p.dataUrl} alt="" className="mt-2 max-h-32 w-full rounded-md object-contain" />)}
              </div>
            );
          })}
          {photos.length === 0 && (
            <p className="rounded-lg bg-[#F4EFE6] p-3 text-xs text-[#8A7F76]">Add photos and they will appear here, placed where you choose.</p>
          )}
        </div>
      </div>
    </div>
  );
}
